import TreatmentPlanRow from "./TreatmentPlanRow"

export default TreatmentPlanRow
